import React, { useState, useEffect, useContext, useRef } from "react"
import axios from 'axios'
import Select from 'react-select'
import useScanDetection from 'use-scan-detection'
import { useReactToPrint } from "react-to-print"
import DataTable from 'react-data-table-component'
import { useDownloadExcel } from 'react-export-table-to-excel'
import html2canvas from "html2canvas"
import { jsPDF } from "jspdf"

import { GlobalContext, HOST } from "./context/GlobalContext"
import { NumeroALetras } from "./PriceToText"

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Modal from 'react-bootstrap/Modal'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Offcanvas from 'react-bootstrap/Offcanvas'

import laJornada from './img/logo.png'

import './App.css';
import { DashCircleFill, FileEarmarkExcelFill, JournalCheck, Pencil, PencilFill, PlusCircle, PlusCircleFill, ReceiptCutoff, Trash3Fill, X } from "react-bootstrap-icons";

const VENTA_UPDATE_API = HOST + '/api/inv/ventas/create/'
const VENTA_GET_BY_ID_API = HOST + '/api/inv/ventas/'
const VENTA_CANCEL_API = HOST + '/api/inv/ventas/cancel/'
const PREFACTURA_UPDATE_API = HOST + '/api/inv/prefactura/create'
const PREFACTURA_MASSIVE_API = HOST + '/api/inv/prefactura/massive'
const PREFACTURA_GET_BY_ID_API = HOST + '/api/inv/prefactura/'
const PREFACTURA_CANCEL_API = HOST + '/api/inv/prefactura/cancel/'

const CURRENCY_FORMAT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
const DATE_FORMAT = new Intl.DateTimeFormat('es', { weekday: 'long', year: 'numeric', month: 'long', day: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })
const HOUR_FORMAT = new Intl.DateTimeFormat('es', { hour: '2-digit', minute: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })
const DATE_FORMAT_SHORT = new Intl.DateTimeFormat('es', { year: 'numeric', month: 'long', day: '2-digit', day: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })

function Ventas() {
  const { getLibros, setGlobalLoading, getISBN, setShowMesage, setMailTitle, setMailBody, getVentas, getNombreLibro, getClientes, getNombreCliente, getPrefacturas, librosList, ventasList, rol, token, clientesList, prefacturasList } = useContext(GlobalContext);

  const [ optionsLibros, setOptionsLibros ] = useState([])
  const [ buyCar, setBuyCar ] = useState([])
  const [ showNoExists,setShowNoExists ] = useState(false)
  const [ key, setKey ] = useState('tpv');
  const [ totalCar, setTotalCar ] = useState(0);
  const [ paymentType, setPaymentType ] = useState('E')
  const [ saleDestitny, setSaleDestitny ] = useState('general')
  const [ loading, setLoading ] = useState( false )
  const [ show, setShow ] = useState( false )
  const [ showTicket, setShowTicket ] = useState( false )
  const [ showCancel, setShowCancel ] = useState( false )
  const [ ticket, setTicket ] = useState(null)
  const [ ticketSelected, setTicketSelected ] = useState(null)
  const [ descuento, setDescuento ] = useState( 0 )
  const [ comment, setComment ] = useState()
  
  const [ dateInit, setDateInit ] = useState( new Date() )
  const [ dateEnd, setDateEnd ] = useState( new Date() )
  const [ paymentTypeF, setPaymentTypeF ] = useState(null)
  const [ saleDestitnyF, setSaleDestitnyF ] = useState(null)
  const [ idVenta, setIdVenta ] = useState(null)

  const [ dateInitP, setDateInitP ] = useState( new Date() )
  const [ dateEndP, setDateEndP ] = useState( new Date() )

  const [ prefactura, setPrefactura ] = useState(null)
  const [ idPrefactura, setIdPrefactura ] = useState(null)
  const [ idCliente, setIdCliente ] = useState(null)
  const [ paymentMethod, setPaymentMethod ] = useState('PUE')
  const [ paymentCondition, setPaymentCondition ] = useState('contado')
  const [ comentario, setComentario ] = useState(null)
  const [ showPrefactura, setShowPrefactura ] = useState(false)
  const [ showPrefacturaPrint, setShowPrefacturaPrint ] = useState(false)
  const [ showPrefacturaTicket, setShowPrefacturaTicket ] = useState(false)
  const [ prefacturaVentasList, setPrefacturaVentasList ] = useState([])
  const [ prefacturaType, setPrefacturaType ] = useState()
  const [ prefacturaDescuentoDetalle, setPrefacturaDescuentoDetalle ] = useState(0)
  const [ prefacturaIVADetalle, setPrefacturaIVADetalle ] = useState(0)

  const [ showNoStock, setShowNoStock ] = useState(false)

  const componentRef = useRef(null)
  const prefacturaRef = useRef(null)
  const tableRef = useRef(null)

  const paymentTypesCatalog = [
    { value: 'E', name: '01 - Efectivo' },
    { value: 'CN', name: '02 - Cheque nominativo' },
    { value: 'T', name: '03 - Tranferencia electrónica de fondos' },
    { value: 'TC', name: '04 - Tarjeta de crédito' },
    { value: 'ME', name: '05 - Monedero electrónico' },
    { value: 'DE', name: '06 - Dinero electrónico' },
    { value: 'VD', name: '08 - Vales de despensa' },
    { value: 'DP', name: '12 - Dación en pago' },
    { value: 'PS', name: '13 - Pago por subragación' },
    { value: 'PC', name: '14 - Pago por consignación' },
    { value: 'C', name: '15 - Condonación' },
    { value: 'CC', name: '17 - Compensación' },
    { value: 'N', name: '23 - Novación' },
    { value: 'CCC', name: '24 - Confusión' },
    { value: 'RD', name: '25 - Remisión de deuda' },
    { value: 'PCC', name: '26 - Prescripción o caducidad' },
    { value: 'SA', name: '27 - A satisfacción del acreedor' },
    { value: 'TD', name: '28 - Tarjeta de débito' },
    { value: 'TS', name: '29 - Tarjeta de servicios' },
    { value: 'AA', name: '30 - Aplicación de anticipos' },
    { value: 'IP', name: '31 - Intermediario pagos' },
    { value: 'PP', name: '00 - PayPal' },
    { value: 'PD', name: '99 - Por Definir' },
  ]

  const facturaLibreria = [ 'TC', 'TD' ]
  const facturaGlobalizada = [ 'E' ]
  const facturaNomina = [ 'PD' ]

  const { onDownload } = useDownloadExcel({
      currentTableRef: tableRef.current,
      filename: 'Ventas_Libreria_' + DATE_FORMAT_SHORT.format((new Date()).getTime()) ,
      sheet: 'Ventas'
  })

  const printFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "Ticket La Jornada"
  });

  const printPrefacturaFn = useReactToPrint({
    contentRef: prefacturaRef,
    documentTitle: "Prefactura La Jornada"
  });

  useEffect(() => {
    setGlobalLoading( true )
    getLibros()
    getClientes()

    let today = new Date()
    setDateInit( today.toISOString().split('T')[0] )
    setDateInitP( today.toISOString().split('T')[0] )
    let tomorrow = new Date(today.getTime() + 86400000)
    setDateEnd( tomorrow.toISOString().split('T')[0] )
    setDateEndP( tomorrow.toISOString().split('T')[0] )
  }, []);

  /*useEffect(() => {
    if( saleDestitny === 'general' ){ 
      setPaymentType('E')
      setPrefacturaType('LIO')
    } else if( saleDestitny === 'library' ) {
      setPaymentType('T')
      setPrefacturaType('LIA')
    } else if( saleDestitny === 'roster' ) {
      setPaymentType('PD')
      setPrefacturaType('LIN')
    }
  }, [ saleDestitny ]);*/

  useEffect(() => {
    console.log('change paymenttype', paymentType)

    if( facturaLibreria.includes(paymentType) ){ 
      setSaleDestitny('library')
      setPrefacturaType('LIO')
      setPaymentMethod('PUE')
    } else if( facturaGlobalizada.includes(paymentType) ) {
      setSaleDestitny('general')
      setPrefacturaType('LIA')
      setPaymentMethod('PUE')
    } else if( facturaNomina.includes(paymentType) ) {
      setSaleDestitny('roster')
      setPrefacturaType('LIN')
      setPaymentMethod('PPD')
    } else {
      setSaleDestitny('general')
      setPrefacturaType('LIA')
      setPaymentMethod('PUE')
    }
  }, [ paymentType ]);

  useEffect(() => {
    if(key === 'report') getVentas( dateInit, dateEnd, saleDestitnyF, paymentTypeF )
    else if(key === 'prefactura') getPrefacturas( dateInitP, dateEndP )

    setFilteredItems([])
    setFilteredItemsP([])
  }, [key]);

  useEffect(() => {
    if( librosList.length > 0 ){
      var temp = []

      librosList.map( item => {
        let cantidad = 0
        let consigna = item.librosAlmacen.find( i => i.libroAlmacenPK.idAlmacen === 0 )
        
        if(consigna) cantidad = consigna.cantidad

        temp.push({ 
          value: item.idLibro, 
          label: item.codigoIsbn + ' - ' + item.titulo, 
          price: item.precioRemision, 
          isbn: item.codigoIsbn,
          cantidad: cantidad,
          descuento: 0,
          iva: 0 })
      })

      setOptionsLibros(temp)
    }
  }, [librosList]);

  useEffect(() => {
    updateTotalCar(buyCar)
  }, [buyCar])

  useEffect(() => {
    if(idCliente === 'n/a') setIdCliente(null)
  }, [idCliente])

  const updateItem = () => {
    setGlobalLoading( true )
    
    let detalles = []
    let descuentoVal = totalCar * ( descuento / 100 )

    buyCar.map( item => {
      detalles.push({ 
        'idLibro': item.idLibro,  
        'cantidad': item.cantidad,
        'monto': item.total,
        'precio': item.precio,
        'descuento': item.descuento,
        'iva': item.iva
      })

      return null
    })

    let json = {
      'idVenta': null,
      'usuarioRegistra': null,
      'fecha': null,
      'monto': totalCar,
      'fechaCancelacion': null,
      'usuarioCancela': null,
      'idPrefactura': null,
      'tipoPago': paymentType,
      'tipoVenta': saleDestitny,
      'idsLibro': detalles,
      'estatus': true,
      'descuento': descuentoVal,
      'condicionPago': paymentCondition,
      'metodoPago': paymentMethod,
      'idCliente': idCliente,
      'comment': comment
    }

    console.log('json to update libros', json)

    axios.post(VENTA_UPDATE_API, json, {
			headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result update", result.data)
      setTicket(result.data.idVenta)
      setShow(true)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const cleanCar = () => {
    setBuyCar([])
    setTotalCar(0)
    setPaymentType('E')
    setPaymentCondition('contado')
    setPaymentMethod('PUE')
    setDescuento(0)
    setIdCliente(null)
    getLibros()
  }

  const downloadPDF = ( id ) => {
    setGlobalLoading( true )

    const infoPageElement = document.getElementById("prefacturaId");
    const pdf = new jsPDF('p', 'mm', 'a4');

    console.log("element pdf", infoPageElement)
    html2canvas(infoPageElement, {
      onclone: document => {},
      scale:3,
      useCORS: true,
      allowTaint: false
    }).then(canvas => {
      pdf.addImage(canvas.toDataURL("image/jpeg"), "JPEG", 5, 5, 200, 288, '', 'FAST');
      pdf.save(`PreFactura_${id.toString().padStart(5, '0')}.pdf`);

      setGlobalLoading( false )
    });

  }

  const onScannerChange = (val) => {
    console.log("codigo", val)
    
    if(val) {
      let libro = getISBN(val)
      console.log("libro found", libro)

      if(libro) {
        addToCar({ 
          value: libro.idLibro, 
          label: libro.titulo, 
          price: libro.precioRemision, 
          isbn: libro.codigoIsbn,
          cantidad: libro.librosAlmacen[0].cantidad,
          descuento: 0,
          iva: 0
        })
      } else { 
        setShowNoExists(true)
      }
    }
  }

  useScanDetection({
    onComplete: onScannerChange,
    minLength: 12 // EAN13
  });

  const addToCar = (e) => {
    let temp = []

    if( e ) {
      if( parseInt(e.cantidad) > 0 ){
        console.log("e value", e)
        buyCar.map( item => {
          temp.push( item )
          return null
        })

        let idx = buyCar.findIndex( (o) => o.idLibro === e.value );
        
        console.log("index found", idx)
        if(idx > -1) {
          if( ( temp[idx].cantidad + 1 ) <= temp[idx].existencia ) {
            temp[idx].cantidad += 1
            temp[idx].total = temp[idx].cantidad * temp[idx].precio
          }
        } 
        else {
          temp.push({ 
            'idLibro': e.value, 
            'titulo': e.label, 
            'isbn': e.isbn, 
            'cantidad': 1, 
            'precio': e.price, 
            'total': ( e.price * 1 ), 
            'descuento': e.descuento, 
            'iva': e.iva,
            'subtotal': 1 * e.price,
            'existencia': e.cantidad  })
        }

        console.log("result to push", temp)
        setBuyCar(temp)
      } else setShowNoStock(true)
    }
  }

  const onChangeInput = (i, e) => {
    let temp = cloneCarList()
    temp[i][e.target.name] = parseFloat(e.target.value)

    let descuento = temp[i].descuento ? ( temp[i].precio * ( temp[i].descuento / 100 ) ) : 0
    let iva = temp[i].iva ? ( (temp[i].precio - descuento) * ( temp[i].iva / 100 ) ) : 0
    
    temp[i].total = temp[i].cantidad * ( temp[i].precio - descuento + iva )
    setBuyCar(temp)
    updateTotalCar(temp)
  }

  /*const onChangeDescuento = (i, val) => {
    let temp = cloneCarList()
    temp[i].descuento = parseFloat(val)

    let descuento = temp[i].descuento ? ( temp[i].precio * ( temp[i].descuento / 100 ) ) : 0
    let iva = temp[i].iva ? ( (temp[i].precio - descuento) * ( temp[i].iva / 100 ) ) : 0
    
    temp[i].total = temp[i].cantidad * ( temp[i].precio - descuento + iva )
    setBuyCar(temp)
    updateTotalCar(temp)
  }

  const onChangeIva = (i, val) => {
    let temp = cloneCarList()
    temp[i].iva = parseFloat(val)

    let descuento = temp[i].descuento ? ( temp[i].precio * ( temp[i].descuento / 100 ) ) : 0
    let iva = temp[i].iva ? ( (temp[i].precio - descuento) * ( temp[i].iva / 100 ) ) : 0
    
    temp[i].total = temp[i].cantidad * ( temp[i].precio - descuento + iva )
    setBuyCar(temp)
    updateTotalCar(temp)
  }*/

  const addQuantity = (i) => {
    let temp = cloneCarList()
    
    if( ( temp[i].cantidad + 1 ) <= temp[i].existencia ) {
      let descuento = temp[i].descuento ? ( temp[i].precio * ( temp[i].descuento / 100 ) ) : 0
      let iva = temp[i].iva ? ( (temp[i].precio - descuento) * ( temp[i].iva / 100 ) ) : 0
      
      temp[i].cantidad += 1
      temp[i].total = temp[i].cantidad * ( temp[i].precio - descuento + iva )
      setBuyCar(temp)
      updateTotalCar(temp)
    }
  }

  const removeQuantity = (i) => {
    let temp = cloneCarList()
    let descuento = temp[i].descuento ? ( temp[i].precio * ( temp[i].descuento / 100 ) ) : 0
    let iva = temp[i].iva ? ( (temp[i].precio - descuento) * ( temp[i].iva / 100 ) ) : 0
    temp[i].cantidad -= 1

    if(temp[i].cantidad > 0) {
      temp[i].total = temp[i].cantidad * ( temp[i].precio - descuento + iva )

      setBuyCar(temp)
      updateTotalCar(temp)
    } else removeItem(temp, i)
  }

  const removeItem = (i) => {
    let temp = cloneCarList()

    temp.splice(i, 1)
    setBuyCar(temp)
  }

  const cloneCarList = () => {
    let temp = []

    buyCar.map( item => {
      temp.push( item )
      return null
    })

    return temp
  }

  const updateTotalCar = (temp) => {
    let result = 0
    
    temp.map( item => {
      result += item.total
    })

    console.log("update total", result)
    setTotalCar(result)
  }

  const getPaymentTypeName = (val) => {
    let result = ''

    paymentTypesCatalog.map( item => {
      if( item.value === val)
        result = item.name
    })

    return result
  }

  const getPaymentMethodName = (val) => {
    let result = null

    if( val === 'PUE' ) result = 'PUE - Pago en una sola exhibición'
    else if(( val === 'PPD' )) result = 'PPD - Pago en Parcialidades o Diferido'

    return result
  }

  const getPaymentDestinyName = (val) => {
    let result = null

    if( val === 'general' ) result = 'Global'
    else if(( val === 'library' )) result = 'Librería'
    else if(( val === 'roster' )) result = 'Nómina'

    return result
  }

  const handleClosePrefactura = () => {
    setShowPrefactura( false )
    setTicketSelected( null )
  }

  const updatePrefactura = (e) => {
    e.preventDefault();
    setGlobalLoading( true )

    var json = { 
      'idVenta': ticketSelected.idVenta,
      'idCliente': idCliente,
      'condicionPago': paymentCondition,
      'metodoPago': paymentMethod,
      'conmentario': comentario,
    }

    console.log('json to update prefactura', json)

    axios.post(PREFACTURA_UPDATE_API, json, {
      headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result update", result.data)
      getVentas( dateInit, dateEnd, saleDestitnyF, paymentTypeF )
      handleClosePrefactura()
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const handlePrefactura = (item) => {
    if( item.idPrefactura ) {
      getPrefacturaById(item.idPrefactura)
    } else {
      setShowPrefactura(true); 
      setTicketSelected( item );
    }
  }

  const handleDirectPrefactura = (item) => {
    setPrefactura( item )
    setShowPrefacturaPrint(true)

    handlePrefacturaTicket(item.idPrefactura, false)
  }

  const getPrefacturaById = (id) => {
    axios({
      method: 'get',
      url: PREFACTURA_GET_BY_ID_API + id,
      headers: { 'Authentication': token }
    })
    .then(result => {
      setPrefactura( result.data )
      setShowPrefacturaPrint(true)
      setGlobalLoading(false)

      handlePrefacturaTicket(result.data.idPrefactura, false)
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const handlePrefacturaTicket = (id, flag) => {
    setGlobalLoading(true)
    axios({
      method: 'get',
      url: VENTA_GET_BY_ID_API + id,
      headers: { 'Authentication': token }
    })
    .then(result => {
      setPrefacturaVentasList( result.data )

      let descuento = 0
      let iva = 0
      result.data.map( venta => {
        venta.ventasDetalle.map( item => {
          descuento += (parseFloat(item.precio) * (parseFloat(item.descuento) / 100)) * parseFloat(item.cantidad)
          iva += (parseFloat(item.precio) * (parseFloat(item.iva) / 100)) * parseFloat(item.cantidad)
        })
      })

      console.log( "descuento e iva detalle", descuento, iva )
      setPrefacturaDescuentoDetalle(descuento)
      setPrefacturaIVADetalle(iva)

      setShowPrefacturaTicket(flag)
      setGlobalLoading(false)
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const handleMassivePrefactura = () => {
    let list = []

    filteredItems.map( item => {
      if( item.tipoVenta === 'general' && item.idPrefactura === null )
        list.push( item.idVenta )
    })

    if( list.length > 0 ) {
      axios.post(PREFACTURA_MASSIVE_API, list, {
        headers: { 'content-type': 'application/json', 'Authentication': token }
      }).then(result => {
        console.log("result update", result.data)
        getVentas( dateInit, dateEnd, saleDestitnyF, paymentTypeF )
        setGlobalLoading( false )
      })
      .catch(error => {
        console.log("error", error.message)
        setShowMesage(true)
        setMailTitle('Error')
        setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
        setGlobalLoading( false )
      })
    }
  }

  const cancelVenta = () => {
    setGlobalLoading( true )

    axios.post(VENTA_CANCEL_API + idVenta, {}, {
      headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result update", result.data)
      setIdVenta(null)
      getVentas( dateInit, dateEnd, saleDestitnyF, paymentTypeF )
      setShowCancel(false)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const cancelPrefactura = () => {
    setGlobalLoading( true )

    axios.post(PREFACTURA_CANCEL_API + idPrefactura, {}, {
      headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result update", result.data)
      setIdPrefactura(null)
      getPrefacturas( dateInitP, dateEndP )
      setShowCancel(false)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  /**************************************** Data Table ****************************************/

  const [filterText, setFilterText] = useState('');
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);

  const columns = [
    {
      name: <th>Ticket</th>,
      selector: row => row.idVenta.toString().padStart(5, '0'),
      sortable: true,
    },
    {
      name: <th>Fecha</th>,
      selector: row => 
        <>
          <div> { DATE_FORMAT_SHORT.format(row.fecha) } </div>
          <div> {HOUR_FORMAT.format(row.fecha) } </div>
        </>,
      sortable: true,
    },
    {
      name: <th>Tipo de Pago</th>,
      selector: row => getPaymentTypeName(row.tipoPago),
      sortable: true,
    },
    {
      name: <th>Destino de Facturación</th>,
      selector: row => row.tipoVenta ? getPaymentDestinyName(row.tipoVenta).toUpperCase() : '',
      sortable: true,
    },
    {
      name: <th>Monto</th>,
      selector: row => CURRENCY_FORMAT.format( row.monto - row.descuento ),
      sortable: true,
    },
    {
      name: <th>Prefactura</th>,
      selector: row => row.idPrefactura ? row.idPrefactura.toString().padStart(5, '0') : 'No Asignada',
      sortable: true,
    },
    {
      cell: row => 
      <>
        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Productos Vendidos</Tooltip>}>
          <JournalCheck onClick={ () => { setShowTicket(true); setTicketSelected( row ); } } className="table-icon" />
        </OverlayTrigger>
        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Factura</Tooltip>}>
          <ReceiptCutoff onClick={ () => { handlePrefactura(row) } } className="table-icon" />
        </OverlayTrigger>
        { !row.idPrefactura ? 
          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Cancelar</Tooltip>}>
            <Trash3Fill onClick={ () => { setShowCancel(true); setIdVenta( row.idVenta ); } } className="table-icon" />
          </OverlayTrigger>
          : <></>
        }
      </>,
    },
  ];

  useEffect(() => {
    if( ventasList.length > 0) {
      let data = ventasList

      if(filterText && filterText !== '' ) {
        data = ventasList.filter(
          item => (item.idVenta && item.idVenta.toString().includes(filterText)),
        )
      }

      console.log("data filtered", data)
      setFilteredItems(data);
    }
  }, [ ventasList, filterText ]);

  /**************************************** Data Table ****************************************/

  /**************************************** Data Table ****************************************/

    const [filterTextP, setFilterTextP] = useState('');
    const [resetPaginationToggleP, ] = useState(false);
    const [filteredItemsP, setFilteredItemsP] = useState([]);
  
    const columnsP = [
      {
        name: <th>Prefactura</th>,
        selector: row => row.idPrefactura.toString().padStart(5, '0'),
        sortable: true,
      },
      {
        name: <th>Fecha</th>,
        selector: row => 
          <>
            <div> { DATE_FORMAT_SHORT.format(row.fecha) } </div>
            <div> {HOUR_FORMAT.format(row.fecha) } </div>
          </>,
        sortable: true,
      },
      {
        name: <th>Cliente</th>,
        selector: row => getNombreCliente( row.idCliente ).razonSocial,
        sortable: true,
      },
      {
        name: <th>Total</th>,
        selector: row => CURRENCY_FORMAT.format( row.total ),
        sortable: true,
      },
      {
        cell: row => 
        <>
          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Ventas Asociadas</Tooltip>}>
            <JournalCheck onClick={ () => { handlePrefacturaTicket(row.idPrefactura, true); setPrefactura( row ); } } className="table-icon" />
          </OverlayTrigger>
          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Factura</Tooltip>}>
            <ReceiptCutoff onClick={ () => { handleDirectPrefactura(row) } } className="table-icon" />
          </OverlayTrigger>
          <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Cancelar</Tooltip>}>
            <Trash3Fill onClick={ () => { setShowCancel(true); setIdPrefactura( row.idPrefactura ); } } className="table-icon" />
          </OverlayTrigger>
        </>,
      },
    ];
  
    useEffect(() => {
      if( prefacturasList.length > 0) {
        let data = prefacturasList
  
        if(filterTextP && filterTextP !== '' ) {
          data = prefacturasList.filter(
            item => (item.idPrefactura && item.idPrefactura.toString().includes(filterTextP)),
          )
        }
  
        console.log("data filtered", data)
        setFilteredItemsP(data);
      }
    }, [ prefacturasList, filterTextP ]);
  
    /**************************************** Data Table ****************************************/

  return ( 
    <>
      <Modal show={showNoStock} onHide={ () => setShowNoStock(false) }>
        <Modal.Header closeButton>
          <div className="title-form">{ 'Sin Existencias' }</div>
        </Modal.Header>
        <Modal.Body>
          <div>
            No podemos agregar este artículo al carrito ya que no tenemos existencia.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="grl-btn" onClick={ () => setShowNoStock(false) }> Aceptar </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showCancel} onHide={ () => { setShowCancel(false); setIdVenta(null); setIdPrefactura(null) } }>
        <Modal.Header closeButton>
          <div className="title-form">{ 'Cancelar Transacción' }</div>
        </Modal.Header>
        <Modal.Body>
          <div>
            ¿Estas seguro de cancelar esta transacción?
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="cancel-btn" onClick={ () => { setShowCancel(false); setIdVenta(null); setIdPrefactura(null) } }> Cerrar </button>
          <button type="button" className="grl-btn" onClick={ () => idVenta ? cancelVenta() : cancelPrefactura() }> Aceptar </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showNoExists} onHide={ () => { setShowNoExists(false) } }>
        <Modal.Header closeButton>
          <div className="title-form">{ 'Producto no encontrado' }</div>
        </Modal.Header>
        <Modal.Body>
          <div>
            Producto no encontrado. Si es nuevo el producto se puede dar de alta en la sección de librería.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="cancel-btn" onClick={ () => { setShowNoExists(false) } }> Cerrar </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showTicket} onHide={ () => { setShowTicket(false); setTicketSelected(null); } } size="lg">
        <Modal.Header closeButton>
          <div className="title-form">{ `Productos Vendidos - Ticket ${ ticketSelected ? ticketSelected.idVenta : ''}` }</div>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              <div className="section-subtitle">Comentarios</div>
              <div className="desc-form">{ ticketSelected && ticketSelected.comment ? ticketSelected.comment : '-' }</div>
            </div>
            <br/>
            <table width='100%'>
                <thead>
                    <tr>
                        <th>Titulo</th>
                        <th>Precio Unitario</th>
                        <th>Cantidad</th>
                        <th>Importe</th>
                    </tr>
                </thead>
                <tbody>
                  { ticketSelected && ticketSelected.ventasDetalle.map( ( item, i ) => (
                    <>
                      <tr>
                        <td>{ getNombreLibro( item.idLibro ).titulo  }</td>
                        <td>{ CURRENCY_FORMAT.format(getNombreLibro( item.idLibro ).precio) }</td>
                        <td>{ item.cantidad }</td>
                        <td>{ CURRENCY_FORMAT.format( item.monto ) }</td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="cancel-btn" onClick={ () => { setShowTicket(false); setTicketSelected(null); } }> Cerrar </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPrefacturaTicket} onHide={ () => { setShowPrefacturaTicket(false); setPrefactura(null); } } size="lg">
        <Modal.Header closeButton>
          <div className="title-form">{ `Tickets Asociados - Prefactura ${ prefactura ? prefactura.idPrefactura.toString().padStart(5, '0') : ''}` }</div>
        </Modal.Header>
        <Modal.Body>
          <div>
            <table width='100%'>
                <thead>
                    <tr>
                        <th>Ticket</th>
                        <th>Fecha</th>
                        <th>Tipo de pago</th>
                        <th>Destino de Facturación</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                  { prefacturaVentasList.map( ( item ) => (
                    <>
                      <tr>
                        <td>{ item.idVenta.toString().padStart(5, '0')  }</td>
                        <td>{ <>
                          <div> { DATE_FORMAT_SHORT.format(item.fecha) } </div>
                          <div> {HOUR_FORMAT.format(item.fecha) } </div>
                        </> }</td>
                        <td>{ getPaymentTypeName(item.tipoPago) }</td>
                        <td>{ item.tipoVenta ? (item.tipoVenta).toUpperCase() : '' }</td>
                        <td>{ CURRENCY_FORMAT.format( item.monto - item.descuento ) }</td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="cancel-btn" onClick={ () => { setShowPrefacturaTicket(false); setPrefactura(null); } }> Cerrar </button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={ () => { setShow( false ); cleanCar()} }>
        <Modal.Header closeButton>
          <div className="title-form">{ 'Venta Registrada' }</div>
        </Modal.Header>
        <Modal.Body>
          <div className="forgoten-pass"> ¿Deseas imprimir ticket? </div>

          <br/>
          <div align="center" ref={componentRef} style={{ backgroundColor: '#fff' }}>
            <div id="divcontents" className="ticket-container">
              <div><img src={ laJornada } alt="logo" className="ticket-logo" /></div>
              <br/>
              <div id="information">
                  <div className="ticket-name">DEMOS DESARROLLO DE MEDIOS</div>
                  <div className="ticket-address">
                    <div>Av. Cuauhtémoc 1236 Santa Cruz, Atoyac</div>
                    <div>Alcaldía Benito Juárez,</div>
                    <div>RFC: DDM840626PM</div>
                  </div>
                  <br/>
              </div>
              <div id="ticket">
                  <div className="no-ticket">No. TICKET: { ticket ? ticket.toString().padStart(5, '0') : '' }</div>
                  <div className="ticket-address">{ DATE_FORMAT.format((new Date()).getTime()) }</div>
              </div>
              <br/>
              <div>
                <table width='100%'>
                  <thead>
                      <tr>
                          <th>CANT</th>
                          <th>PRECIO U.</th>
                          <th>DTO.</th>
                          <th>IVA</th>
                          <th>IMPORTE</th>
                      </tr>
                  </thead>
                  <tbody>
                    { buyCar.map( ( item, i ) => (
                      <>
                        <tr>
                          <td colspan="5" className="ticket-td-title">{ `${ item.isbn } - ${ item.titulo }`  }</td>
                        </tr>
                        <tr>
                            <td className="ticket-td">{item.cantidad}</td>
                            <td className="ticket-td">{ CURRENCY_FORMAT.format( item.precio ) }</td>
                            <td className="ticket-td">{ CURRENCY_FORMAT.format( item.precio * (item.descuento ? (item.descuento/100) : 0) ) }</td>
                            <td className="ticket-td">{ CURRENCY_FORMAT.format( item.precio * (item.iva ? (item.iva/100) : 0) ) }</td>
                            <td className="ticket-td">{ CURRENCY_FORMAT.format( item.total ) }</td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </table>
              </div>

              <br/>
              <div align="right">
                <table>
                  <tr>
                    <td><b>SUBTOTAL:</b>&nbsp;&nbsp;</td>
                    <td>{ CURRENCY_FORMAT.format( totalCar ) }</td>
                  </tr>
                  <tr>
                    <td><b>DESCUENTO GLOBAL:</b>&nbsp;&nbsp;</td>
                    <td>{ CURRENCY_FORMAT.format( (totalCar * ( descuento / 100 )) ) }</td>
                  </tr>
                  <tr>
                    <td><b>TOTAL:</b></td>
                    <td><b>{ CURRENCY_FORMAT.format( totalCar - (totalCar * ( descuento / 100 )) ) }</b></td>
                  </tr>
                  <tr>
                    <td colspan="2"><br/></td>
                  </tr>
                </table>
              </div>
              <div>
                <div><b>FORMA DE PAGO</b></div>
                <div>{ getPaymentTypeName(paymentType) }</div>
              </div>
              <br/>
              <div className="ticket-td"> Para obtener su CFDI deberá solicitarse dentro del mismo mes de compra <b>@gmail.com</b> </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="cancel-btn" onClick={ () => { setShow( false ); cleanCar() }}> Cerrar </button>
          <button type="button" className="grl-btn" onClick={ () => printFn() }> Imprimir </button>
        </Modal.Footer>
      </Modal>

      <Modal size="xl" show={showPrefacturaPrint} onHide={ () => { setShowPrefacturaPrint( false ); setTicketSelected(null); setPrefactura(null); }}>
        <Modal.Header closeButton>
          <div className="title-form">{ 'Venta Registrada' }</div>
        </Modal.Header>
        <Modal.Body>
          <div> ¿Deseas imprimir la prefactura? </div>
          
          { prefactura && <>
            <br/>
            <div align="center" ref={prefacturaRef} style={{ backgroundColor: '#fff' }}>
              <div id="prefacturaId" className="prefactura-container">
                <div className="prefactura-container-component">
                  <Row>
                    <div> ESTE DOCUMENTO ES UNA REPRESENTACIÓN IMPRESA DE UN CFDI. </div>
                    <div> EMISOR: <b>DEMOS DESARROLLO DE MEDIOS</b> </div>
                  </Row>
                  <br/>
                  <Row>
                    <Col md={ 4 }> <br/><br/><br/><div><img src={ laJornada } alt="logo" className="prefactura-logo" /></div> </Col>
                    <Col md={ 6 }>
                      <Container  className="prefactura-container-component" style={{ padding: 0 }}>
                        <Row>
                          <Col md={ 6 }>
                            <div className="ticket-name">DEMOS DESARROLLO DE MEDIOS</div>
                            <div className="ticket-address">
                              <div>DDM840626PM</div>
                            </div>
                            <div> <b>REGIMEN FISCAL:</b> 601 - General de Ley Personas Morales </div>

                            <br/>
                            <div> <b>CONDICIONES DE PAGO:</b> { prefactura.condicionPago.toUpperCase() } </div>
                            <div> <b>FORMA DE PAGO:</b> { getPaymentTypeName(prefactura.tipopago) } </div>
                            <div> <b>MÉTODO DE PAGO:</b> { getPaymentMethodName(prefactura.metodoPago) } </div>
                            <div> <b>USO CFDI:</b> { 'S01 - Sin efectos fiscales' } </div>
                          </Col>
                          <Col md={ 6 }>

                            <div> <b>TIPO DE COMPROBANTE:</b> I - Ingreso </div>
                            <div> <b>FOLIO FISCAL:</b> </div>
                            <div> <b>NUMERO DE SERIE DEL CERTIFICADO DEL SAT:</b></div>
                            <div> <b>FECHA Y HORA DE CERTIFICACIÓN:</b></div>
                            <div> <b>NUMERO DE SERIE DEL CSD DEL EMISOR:</b> 00001000000513659755 </div>
                            <div> <b>CLAVE CONFIRMACIÓN:</b> </div>
                          
                          </Col>
                        </Row>

                        <Row>
                          <Col md={ 6 }>
                            <br/><br/>
                            <div> <b>PARA: "{ getNombreCliente( prefactura.idCliente ).razonSocial }" </b> </div>
                            <div> <b>{ getNombreCliente( prefactura.idCliente ).rfc }</b> </div>
                            <div> Regimen Fiscal: 616 - Sin obligaciones fiscales </div>

                            <br/><br/>
                            <div> <b>RESIDENCIA FISCAL:</b> MEX </div>
                            <div> <b>NumRegidTribs</b> </div>
                          </Col>
                          <Col>
                          <br/><br/>
                            <div> <b>Domicilio:</b> </div>
                            <div> <b>Colonia:</b> </div>
                            <div> <b>C.P.:</b> 03310 <b> Municipio/Alcaldia: </b></div>

                            <br/>
                            <div> <b>Notas:</b></div>
                            <div> <b>Convenio:</b> </div>
                            <div> <b>Orden:</b>  </div>
                          </Col>
                        </Row>
                      </Container>
                      
                    </Col>
                    <Col md={ 2 }>
                      <div><b>FACTURA</b></div>
                      <div><b>FOLIO: { prefacturaType } { prefactura.idPrefactura.toString().padStart(5, '0') }</b></div>
                      <br/>
                      <div> FECHA: { DATE_FORMAT_SHORT.format( prefactura.fecha ) } { HOUR_FORMAT.format(prefactura.fecha) }</div>
                      <div> LUGAR DE EXPEDICIÓN: 03310 </div>
                    </Col>
                  </Row>
                </div>
                
                <br/>
                <div className="prefactura-container-component">
                  <Row>
                    <Col>
                      <table width='100%' className="prefactura-table">
                        <thead>
                          <tr>
                              <th width="5%" className="prefactura-th">CANTIDAD</th>
                              <th width="5%" className="prefactura-th">CLAVE PROD/SERV</th>
                              <th width="5%" className="prefactura-th">CLAVE UNIDAD</th>
                              <th width="5%" className="prefactura-th">UNIDAD DE MEDIDA</th>
                              <th width="60%" className="prefactura-th" style={{ textAlign: 'left' }}>DESCRIPCIÓN</th>
                              <th width="10%" className="prefactura-th">VALOR UNITARIO</th>
                              { prefacturaType !== 'LIA' && <th width="10%" className="prefactura-th">DESCUENTOS</th> }
                              { prefacturaType !== 'LIA' && <th width="10%" className="prefactura-th">IMPUESTOS</th> }
                              <th width="10%" className="prefactura-th">IMPORTE</th>
                          </tr>
                        </thead>
                        <tbody>
                          { prefacturaType !== 'LIA' ?
                            <>
                              { prefacturaVentasList.map( venta => (
                                venta.ventasDetalle.map( item => (
                                  <tr>
                                    <td className="prefactura-td">{ item.cantidad }</td>
                                    <td className="prefactura-td">14111807</td>
                                    <td className="prefactura-td">H87</td>
                                    <td className="prefactura-td">Pieza</td>
                                    <td className="prefactura-td">{ getNombreLibro( item.idLibro ).titulo }</td>
                                    <td className="prefactura-td">{ (item.precio).toFixed(2) }</td>
                                    <td className="prefactura-td">{ ( ((item.precio * item.descuento) / 100 )) * item.cantidad }</td>
                                    <td className="prefactura-td">{ ( ((item.precio * item.iva) / 100 )) * item.cantidad }</td>
                                    <td className="prefactura-td">{ (item.precio * item.cantidad).toFixed(2) }</td>
                                  </tr>
                                ))
                              ))}
                            </> :
                            <tr>
                              <td className="prefactura-td">1</td>
                              <td className="prefactura-td">14111807</td>
                              <td className="prefactura-td">H87</td>
                              <td className="prefactura-td">Pieza</td>
                              <td className="prefactura-td"></td>
                              <td className="prefactura-td">{ (prefactura.subtotal).toFixed(2) }</td>
                              <td className="prefactura-td">{ (prefactura.subtotal).toFixed(2) }</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                </div>

                <br/><br/>
                <div className="prefactura-container-component">
                  <Row>
                    <Col md={ 8 }>
                      <div><b>TIPO RELACIÓN:</b></div>
                      <div><b>CFDI RELACIONADO:</b></div>
                    </Col>
                    <Col md={ 3 }>
                      <div style={{ textAlign: 'right' }}>
                        <div><b>SUBTOTAL:</b></div>
                        <div><b>{ ( ((prefactura.descuento) / prefactura.subtotal ) * 100 ).toFixed(2) }% DESCUENTO:</b> {}</div>
                        <div><b>IMPUESTOS TRASLADADOS:</b></div>
                        <div><b>IMPUESTOS RETENIDOS:</b></div>
                        <br/>
                        <div><b>TOTAL:</b></div>
                      </div>
                    </Col>
                    <Col md={ 1 }>
                      <div style={{ textAlign: 'right' }}>
                        <div><b>{ prefactura.subtotal.toFixed(2) }</b></div>
                        <div><b>{ prefactura.descuento.toFixed(2) }</b></div>
                        <div><b>{ prefactura.impuestoTrasladado.toFixed(2) }</b></div>
                        <div><b>{ prefactura.impuestoRetenido.toFixed(2) }</b></div>
                        <br/>
                        <div><b>{ (prefactura.total).toFixed(2) }</b></div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <div style={{ textAlign: 'right' }}>
                      <br/>
                      <div className="prefactura-total">{ NumeroALetras(prefactura.total) } M.N.</div>
                      <div>MONEDA: <b>Peso mexicano</b> TIPO DE CAMBIO: <b>1.00</b></div>
                    </div>
                  </Row>
                </div>

                <br/><br/><br/>
                <div>EL SOLICITANTE se obliga a proporcionar a DEMOS, Desarrollo de Medios, S.A. de C.V. el material a publicar mismo que en caso de ser necesario eberá contar con las autorizaciones o permisos respectivos. DEMOS, Desarrollo de Medios, S.A. de C.V., no será responsable frente a tercero de contenido del material respecto de las marcas, diseños, nombres, reservas, títulos, modelos, artículos, fotografías o cualquier otro derecho de propiedad intelectual y/o del contenido en general que pudiera ocasionar daños y perjuicios o daño moral a terceros; para el caso de que surgiera algún reclamo al respecto WL SOLICITANTE releva a DEMOS, Desarrollo de Medios, S.A. de C.V. de cualquier responsabilidad legal que pudiera surgir derivada de la solicitud expresa que realiza en este acto, por lo que se compromete a sacar en paz y a salvo a DEMOS, Desarrollo de Medios, S.A. de C.V. de cualquier reclamación administrativa, judicial, penal o extrajudicial en su contra, por este motivo y asumir integramente costo del litigio que en su caso llegare a presentarse.</div>

                <br/>
                <div className="prefactura-footer">SELLO DIGITAL DEL SAT:</div>
                <div className="prefactura-footer">SELLO DIGITAL DEL CFDI:</div>
                <div className="prefactura-footer">CADENA ORIGINAL DEL COMPLEMENTO DE CERTIFICACIÓN DIGITAL DEL SAT:</div>

              </div>
            </div>
          </>}
          
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="cancel-btn" onClick={ () => { setShowPrefacturaPrint( false ); setTicketSelected(null); setPrefactura(null); }}> Cerrar </button>
          <button type="button" className="grl-btn" onClick={ () => printPrefacturaFn() }> Imprimir </button>
          <button type="button" className="grl-btn" onClick={ () => downloadPDF( prefactura.idPrefactura ) }> Descargar en PDF </button>
        </Modal.Footer>
      </Modal>

      <Offcanvas show={showPrefactura} onHide={ () => handleClosePrefactura() } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">Prefactura</div>
            <div className="desc-form"> { 'Ticket ' + ( ticketSelected != null ? ticketSelected.idVenta.toString().padStart(5, '0') : '0' ) } </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form id="prefacturaForm" onSubmit={ updatePrefactura }>
            <Container>
              <Row>
                <div>
                  <input type="hidden" name="idPrefactura" value={ idPrefactura } />
                  <Container>
                    <Row>
                      <Col md="12">
                        <FloatingLabel label="Cliente Remisionado">
                          <Form.Select required name="idCliente" value={ idCliente } onChange={ (e) => setIdCliente( e.target.value ) }>
                            <option>{ '' }</option>
                            { clientesList.map( item => (
                              <option key={ item.idCliente } value={ item.idCliente }>{ item.razonSocial }</option>
                            )) }
                          </Form.Select>
                        </FloatingLabel>
                      </Col>

                      <Col md={ 6 }>
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Método de pago">
                            <Form.Select required name="paymentMethod" value={ paymentMethod } onChange={ (e) => setPaymentMethod( e.target.value ) }>
                              <option>{ 'N/A' }</option>
                              <option value={ 'PUE' }>{ 'PUE - Pago en una sola exhibición' }</option>
                              <option value={ 'PPD' }>{ 'PPD - Pago en Parcialidades o Diferido' }</option>
                            </Form.Select>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md={ 6 }>
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Condición de pago">
                            <Form.Select required name="paymentCondition" value={ paymentCondition } onChange={ (e) => setPaymentCondition( e.target.value ) }>
                              <option value={ 'contado' }>{ 'Contado' }</option>
                              <option value={ '15 días' }>{ '1 Catorcena' }</option>
                              <option value={ '30 días' }>{ '2 Catorcenas' }</option>
                              <option value={ '45 días' }>{ '3 Catorcenas' }</option>
                              <option value={ '60 días' }>{ '4 Catorcenas' }</option>
                              <option value={ '75 días' }>{ '5 Catorcenas' }</option>
                              <option value={ '90 días' }>{ '6 Catorcenas' }</option>
                            </Form.Select>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>

                      <Col md={ 12 }>
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Comentario">
                            <Form.Control name="comentario" value={ comentario } onChange={ (e) => setComentario( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Container>
                  
                  <br/>
                  <div align="center">
                    <button type="button" className="cancel-btn" onClick={ () => handleClosePrefactura() } >{ 'Cancelar' }</button>&nbsp;&nbsp;
                    <button type="submit" className="grl-btn">{ 'Guardar' }</button>
                  </div>
                </div>
              </Row>
            </Container>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
      
      <Container className='main-component'>
        <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
          <Tab eventKey="tpv" title={ <div className="section-subtitle"> Punto de Venta </div> }>
            
            <div>
              <Container>
                <Row>
                  <Col>
                    <br/>
                    <Form.Group className='mb-3'>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        placeholder="Libros..."
                        isClearable={true}
                        isSearchable={true}
                        name="color"
                        value={null}
                        options={optionsLibros}
                        getOptionLabel={(option) => `${option.label} ( Existencia: ${option.cantidad} )`}
                        onChange={ (e) => addToCar(e) }
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Container>

              <br/>
              <Container>
                <Row>
                  <Col md={ 12 }>
                    <div className="tvp-total-container">
                      <Container style={{ padding: 0 }}>
                        <Row>
                          <Col md={ 3 }>
                            <Form.Group className='mb-3'>
                              <FloatingLabel label="Cliente Remisionado">
                                <Form.Select required name="idCliente" value={ idCliente } onChange={ (e) => setIdCliente( e.target.value ) }>
                                  <option value={ 'n/a' }>{ '-' }</option>
                                  { clientesList.map( item => (
                                    <option key={ item.idCliente } value={ item.idCliente }>{ item.razonSocial }</option>
                                  )) }
                                </Form.Select>
                              </FloatingLabel>
                            </Form.Group>
                          </Col>
                          <Col md={ 3 }>
                            <Form.Group className='mb-3'>
                              <FloatingLabel label="Forma de pago">
                                <Form.Select required name="paymentType" value={ paymentType } onChange={ (e) => setPaymentType( e.target.value ) }>
                                  { paymentTypesCatalog.map( item => (
                                    <option value={ item.value }>{ item.name }</option>
                                  )) }
                                </Form.Select>
                              </FloatingLabel>
                            </Form.Group>
                          </Col>
                          <Col md={ 3 }>
                            <Form.Group className='mb-3'>
                              <FloatingLabel label="Destino de facturación">
                                <Form.Select required name="saleDestitny" value={ saleDestitny } onChange={ (e) => setSaleDestitny( e.target.value ) }>
                                  <option value={ 'general' }>{ 'Globales' }</option>
                                  <option value={ 'library' }>{ 'Librería' }</option>
                                  <option value={ 'roster' }>{ 'Nómina' }</option>
                                </Form.Select>
                              </FloatingLabel>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <FloatingLabel label="Comentario">
                                <Form.Control name="comment" value={ comment } onChange={ (e) => setComment( e.target.value ) } placeholder="" />
                              </FloatingLabel>
                            </Form.Group>
                          </Col>
                          
                          { idCliente != null &&
                            <>
                              <Col md={ 3 }>
                                <Form.Group className='mb-3'>
                                  <FloatingLabel label="Método de pago">
                                    <Form.Select required name="paymentMethod" value={ paymentMethod } onChange={ (e) => setPaymentMethod( e.target.value ) }>
                                      <option value={ 'PUE' }>{ 'PUE - Pago en una sola exhibición' }</option>
                                      <option value={ 'PPD' }>{ 'PPD - Pago en Parcialidades o Diferido' }</option>
                                    </Form.Select>
                                  </FloatingLabel>
                                </Form.Group>
                              </Col>
                              <Col md={ 3 }>
                                <Form.Group className='mb-3'>
                                  <FloatingLabel label="Condición de pago">
                                    <Form.Select required name="paymentCondition" value={ paymentCondition } onChange={ (e) => setPaymentCondition( e.target.value ) }>
                                      <option value={ 'contado' }>{ 'Contado' }</option>
                                      <option value={ '15 días' }>{ '1 Catorcena' }</option>
                                      <option value={ '30 días' }>{ '2 Catorcenas' }</option>
                                      <option value={ '45 días' }>{ '3 Catorcenas' }</option>
                                      <option value={ '60 días' }>{ '4 Catorcenas' }</option>
                                      <option value={ '75 días' }>{ '5 Catorcenas' }</option>
                                      <option value={ '90 días' }>{ '6 Catorcenas' }</option>
                                    </Form.Select>
                                  </FloatingLabel>
                                </Form.Group>
                              </Col>
                            </>
                          }
                          
                        </Row>
                      </Container>
                    </div>
                  </Col>

                  <Col md={ 12 } className="tvp-container">
                    
                    <table width={'100%'}>
                      <th className="td-custom"> Cantidad </th>
                      <th className="td-custom"> Código ISBN </th>
                      <th className="td-custom"> Producto </th>
                      <th className="td-custom"> Precio Unitario </th>
                      <th className="td-custom"> Existencia </th>
                      <th className="td-custom"> Descuento </th>
                      <th className="td-custom"> Impuesto </th>
                      <th className="td-custom"> P. Costo </th>
                      <th className="td-custom"> Importe </th>
                      <th></th>
                      <tbody>
                        { buyCar.map( ( item, i ) => (
                          <tr index={ item.idLibro }>
                            <td className="td-custom"> 
                              <DashCircleFill onClick={ () => removeQuantity(i) } className="tvp-button" />&nbsp;&nbsp;&nbsp;
                              { item.cantidad }&nbsp;&nbsp;&nbsp;
                              <PlusCircleFill onClick={ () => addQuantity(i)} className="tvp-button" />
                            </td>
                            <td className="td-custom">{ item.isbn }</td>
                            <td className="td-custom">{ item.titulo }</td>
                            <td className="td-custom">{ 
                              //CURRENCY_FORMAT.format( item.precio ) 
                              <Form.Group className='mb-3'>
                                <FloatingLabel label="Precio">
                                  <Form.Control type="number" name="precio" value={ item.precio } onChange={ (e) => onChangeInput( i, e ) } placeholder="" />
                                </FloatingLabel>
                              </Form.Group>
                            }</td>
                            <td className="td-custom"><b>{ item.existencia }</b></td>
                            <td>
                              <Form.Group className='mb-3'>
                                <FloatingLabel label="Descuento ( % )">
                                  <Form.Control type="number" name="descuento" value={ item.descuento } onChange={ (e) => onChangeInput( i, e ) } placeholder="" />
                                </FloatingLabel>
                              </Form.Group>
                            </td>
                            <td>
                              <Form.Group className='mb-3'>
                                <FloatingLabel label="Impuesto ( % )">
                                  <Form.Control type="number" name="iva" value={ item.iva } onChange={ (e) => onChangeInput( i, e ) } placeholder="" />
                                </FloatingLabel>
                              </Form.Group>
                            </td>
                            <td className="td-custom">{ CURRENCY_FORMAT.format( item.precio - ( item.precio * ( item.descuento ? item.descuento / 100 : 0 ) ) + ( (item.precio - ( item.precio * ( item.descuento ? item.descuento / 100 : 0 ) )) * ( item.iva ? item.iva / 100 : 0 ) ) ) }</td>
                            <td className="td-custom">{ CURRENCY_FORMAT.format( item.total ) }</td>
                            <td>
                              <Trash3Fill onClick={ () => removeItem(i) } className="table-icon" /> 
                            </td>
                          </tr>
                        )) }
                        { buyCar.length === 0 &&
                          <tr>
                            <td style={{ padding: '20px 5px' }}> Sin productos en el carrito </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                    
                  </Col>

                  <Col md={ 8 }/>
                  <Col md={ 4 }>
                    <div className="tvp-total-container">
                      <div className="desc-form" style={{ textAlign: 'right' }}> Total de la compra </div>
                      <div className="tvp-total" style={{ textAlign: 'right' }}>{ CURRENCY_FORMAT.format( totalCar - (totalCar * ( descuento / 100 )) ) }</div>
                    </div>
                    <div align="right">
                      <div style={{ width: '50%' }}>
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Descuento Global ( % )">
                            <Form.Control type="number" name="descuento" value={ descuento } onChange={ (e) => setDescuento( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </div>
                    </div>
                    <br/>
                    <div style={{ textAlign: 'right' }}>
                      <Button disabled={ loading } className='tvp-btn' onClick={ () => updateItem() }>
                        <Spinner animation="border" variant="light" role="status" className={ loading ? 'spin' : 'hide' }/>
                        <span className={ loading ? 'hide' : 'btn-text' }> COBRAR </span>
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>

          </Tab>
          <Tab eventKey="report" title={ <div className="section-subtitle"> Ventas </div> }>
            <Container >
              {/*<Row>
                <Col md={ 12 }>
                  <Form.Group className='mb-3'>
                    <FloatingLabel label="Buscar por titulo">
                      <Form.Control id="search" value={filterText} onChange={ (e) => setFilterText(e.target.value) } placeholder="" />
                    </FloatingLabel>
                  </Form.Group>
                </Col>
              </Row>*/}
                <Row>
                  <Col md={ 12 }>
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Buscar por número de Ticket (omita los ceros a la izquierda)">
                        <Form.Control id="search" value={filterText} onChange={ (e) => setFilterText(e.target.value) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md={ 2 }>
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Fecha de Inicio">
                        <Form.Control type="date" defaultValue={ dateInit } value={ dateInit } onChange={ (e) => setDateInit( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md={ 2 }>
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Fecha de Fin">
                        <Form.Control type="date" value={ dateEnd } onChange={ (e) => setDateEnd( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md={ 3 }>
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Destino de facturación">
                        <Form.Select required name="saleDestitnyF" value={ saleDestitnyF } onChange={ (e) => setSaleDestitnyF( e.target.value ) }>
                          <option>Selecciona una opción</option>
                          <option value={ 'general' }>{ 'Global' }</option>
                          <option value={ 'library' }>{ 'Librería' }</option>
                          <option value={ 'roster' }>{ 'Nómina' }</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md={ 3 }>
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Tipo de pago">
                        <Form.Select required name="paymentTypeF" value={ paymentTypeF } onChange={ (e) => setPaymentTypeF( e.target.value ) }>
                          <option>Selecciona una opción</option>
                          { paymentTypesCatalog.map( item => (
                            <option value={ item.value }>{ item.name }</option>
                          ))}
                        </Form.Select>
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md={ 2 }>
                    <button className="grl-btn" onClick={ () => { setFilteredItems([]); getVentas( dateInit, dateEnd, saleDestitnyF, paymentTypeF ) } }>{ 'Buscar' }</button>
                  </Col>
              </Row>
              <Row>
                { filteredItems.length > 0 && 
                  <>
                    <div align="right">
                      <button className="simple-grl-btn" onClick={ () => handleMassivePrefactura() }>
                        <ReceiptCutoff />&nbsp;&nbsp;Generar Prefactura de la lista
                      </button>&nbsp;&nbsp;
                      <button className="simple-grl-btn" onClick={ onDownload }>
                        <FileEarmarkExcelFill />&nbsp;&nbsp;Exportar a Excel
                      </button>
                    </div>
                    <DataTable
                      columns={columns}
                      data={filteredItems}
                      pagination
                      paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                      persistTableHead
                    />
                  </>
                }
                { filteredItems.length === 0 && 
                  <div>Sin registros</div>
                }
              </Row>
            </Container>
          </Tab>

          <Tab eventKey="prefactura" title={ <div className="section-subtitle"> Prefacturas </div> }>
            <Container >
                <Row>
                  <Col md={ 12 }>
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Buscar por número de Prefactura (omita los ceros a la izquierda)">
                        <Form.Control id="search" value={filterTextP} onChange={ (e) => setFilterTextP(e.target.value) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md={ 3 }>
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Fecha de Inicio">
                        <Form.Control type="date" defaultValue={ dateInitP } value={ dateInitP } onChange={ (e) => setDateInitP( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md={ 3 }>
                    <Form.Group className='mb-3'>
                      <FloatingLabel label="Fecha de Fin">
                        <Form.Control type="date" value={ dateEndP } onChange={ (e) => setDateEndP( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Form.Group>
                  </Col>
                  <Col md={ 2 }>
                    <button className="grl-btn" onClick={ () => { setFilteredItemsP([]); getPrefacturas( dateInitP, dateEndP ) } }>{ 'Buscar' }</button>
                  </Col>
              </Row>
              <Row>
                { filteredItemsP.length > 0 && 
                  <>
                    <DataTable
                      columns={columnsP}
                      data={filteredItemsP}
                      pagination
                      paginationResetDefaultPage={resetPaginationToggleP} // optionally, a hook to reset pagination to page 1
                      persistTableHead
                    />
                  </>
                }
                { filteredItemsP.length === 0 && 
                  <div>Sin registros</div>
                }
              </Row>
            </Container>
          </Tab>
        </Tabs>
      </Container>

      <div className="hide-books">
        <table  ref={tableRef}>
          <tbody>
            <tr>
                <th>Ticket</th>
                <th>Fecha</th>
                <th>Tipo de Pago</th>
                <th>Destino de Facturación</th>
                <th>Monto</th>
                <th>Prefactura</th>
            </tr>
            { filteredItems.map( item => {
              return <tr>
                <td>{ item.idVenta.toString().padStart(5, '0') }</td>
                <td>{ DATE_FORMAT_SHORT.format(item.fecha) } { HOUR_FORMAT.format(item.fecha) }</td>
                <td>{ getPaymentTypeName(item.tipoPago) }</td>
                <td>{ item.tipoVenta ? (item.tipoVenta).toUpperCase() : '' }</td>
                <td>{ CURRENCY_FORMAT.format( item.monto - item.descuento ) }</td>
                <td>{ item.idPrefactura ? item.idPrefactura.toString().padStart(5, '0') : 'No Asignada' }</td>
              </tr>
            })}
          </tbody>
        </table>
      </div>

    </>
  );
}

export default Ventas;
